module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f0740e_banner_800x600.5f319794.png";